import React from "react";
import { useNavigate } from "react-router-dom";

import AthleteForm from "../components/forms/AthleteForm";
import { useAuth } from "../context/AuthContext";

const AthleteProfileRoute = ({ initialTab, formMode }) => {
  const navigate = useNavigate();
  const { athleteData } = useAuth();

  return (
    <AthleteForm
      initialData={athleteData}
      initialTab={initialTab}
      formMode={formMode}
      athleteId={athleteData?.id}
      onBack={() => navigate("/athlete/dashboard")}
    />
  );
};

export default AthleteProfileRoute;
